/**
 * @file Front Page
 */

/**
 * Front Page functions.
 *
 * Runs js specific to the Front Page template.
 */
const vFrontPage = () => {
	import('../../components/sticky-header/sticky-header').then(({ default: vStickyHeader }) => { vStickyHeader(); });
	import('../../components/hp-curtain/hp-curtain').then(({ default: vHpCurtain }) => { vHpCurtain(); });
	import('../../components/hp-hero-anniversary/hp-hero-anniversary').then(({ default: vHpHeroAnniversary }) => { vHpHeroAnniversary(); });
	import('../../components/hp-about/hp-about').then(({ default: vHpAbout }) => { vHpAbout(); });
	import('../../components/hp-gradient-banner/hp-gradient-banner').then(({ default: vHpGradientBanner }) => { vHpGradientBanner(); });
	import('../../components/hp-featured-cs/hp-featured-cs').then(({ default: vHpFeaturedCs }) => { vHpFeaturedCs(); });
	import('../../components/hp-industries-anniversary/hp-industries-anniversary').then(({ default: vHpIndustriesAnniversary }) => { vHpIndustriesAnniversary(); });
	import('../../components/hp-ctas/hp-ctas').then(({ default: vHpCtas }) => { vHpCtas(); });
};

if (document.readyState !== 'loading') {
	vFrontPage();
} else {
	document.addEventListener('DOMContentLoaded', vFrontPage);
}
